import React, { useId } from 'react'

// types
import { CategoryResponse, LoadSalonsFromFiltersParams, SalonsCategoryPageQuery, SubcategoryChangeEventInteraction } from '../../../../types/types'

// utils
import { findSmallestIndexMatch } from '../../../../utils/helper'
import { getSubcategoryChangeEvent } from '../../../../utils/dataLayerEvents'
import { pushToDataLayer } from '../../../../utils/dataLayer'

// hooks
import useMessages from '../../../../hooks/useMessages'

// components
import ElementsSlider from '../../../../components/ElementsSlider/ElementsSlider'
import VisuallyHidden from '../../../../atoms/VisuallyHidden/VisuallyHidden'

// styles
import * as SC from './SubcategoriesNavigationStyles'

type Props = {
	categorySlug: string
	categoryData: CategoryResponse
	query: SalonsCategoryPageQuery
	updateQueryFromFilters: (query: LoadSalonsFromFiltersParams) => void
}

// component
const SubcategoriesNavigation = (props: Props) => {
	const { categorySlug, categoryData, query, updateQueryFromFilters } = props
	const { messages } = useMessages()
	const headingId = useId()

	const sliderCategories = categoryData.category.children || []

	const firstSelectedSubcategoryID = findSmallestIndexMatch(
		query.categoryIDs,
		sliderCategories.map((category) => category.id)
	)

	const handleSubCategoryButtonClick = (categoryID: string) => {
		const queryCategoryIDs = query.categoryIDs
		let newCategoryIDs: string[]
		let eventInteraction: SubcategoryChangeEventInteraction

		if (queryCategoryIDs.includes(categoryID)) {
			newCategoryIDs = queryCategoryIDs.filter((cID) => cID !== categoryID)
			eventInteraction = 'click_remove'
		} else {
			newCategoryIDs = [...queryCategoryIDs, categoryID]
			eventInteraction = 'click_add'
		}

		// push to dataLayer
		const event = getSubcategoryChangeEvent({
			eventInteraction,
			clickedCategoryID: categoryID,
			clickedCategorySlug: categorySlug
		})
		pushToDataLayer(event)

		updateQueryFromFilters({ categoryIDs: newCategoryIDs })
	}

	return (
		<SC.SubcategoriesSliderWrapper role='group' aria-labelledby={headingId}>
			<VisuallyHidden as='h3' id={headingId}>
				{messages.Subcategories}
			</VisuallyHidden>
			<ElementsSlider initScrolledElementID={firstSelectedSubcategoryID} gap={'8px'}>
				{sliderCategories.map((category) => {
					return (
						<SC.SubcategoryButton
							type='button'
							onClick={() => handleSubCategoryButtonClick(category.id)}
							$isSelected={query.categoryIDs.includes(category.id)}
							key={category.id}
						>
							<span>{category.name}</span>
						</SC.SubcategoryButton>
					)
				})}
			</ElementsSlider>
		</SC.SubcategoriesSliderWrapper>
	)
}

export default SubcategoriesNavigation
